import React, { useState, useEffect } from "react";
import { GetAllPosts } from "./API";
import Post from "./Post";

export default function PostList(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
    GetAllPosts(props.crsnum).then(data => {
      console.log(data);
      setData(data);
    });
  }, [props.crsnum,props.addedCount]);
  return (
    <React.Fragment>
      {data.map((item, index) => (
        <Post Lang={props.Lang} postaddedCount={props.addedCount} crsnum={props.crsnum} key={item.id} {...item} />
      ))}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Community/PostList.js